import { render, staticRenderFns } from "./RedIcon.vue?vue&type=template&id=26c5748b&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26c5748b')) {
      api.createRecord('26c5748b', component.options)
    } else {
      api.reload('26c5748b', component.options)
    }
    module.hot.accept("./RedIcon.vue?vue&type=template&id=26c5748b&", function () {
      api.rerender('26c5748b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/RedIcon.vue"
export default component.exports